import React from 'react';
import { useEffect, useState, useCallback } from "react"; // Added useCallback for potential future use if onSelect were a dependency
import { useDispatch, useSelector } from "react-redux";

import OpcSelect from "../../components/select/src";
import { toAbsoluteUrl } from "../../../Utils/_helpers";

const getOpcSelectIcon = () => {
  return (
    <span className="">
      <img
        alt=""
        className="t-dp"
        src={toAbsoluteUrl("/media/sr/icons/sr_number.svg")}
      />
    </span>
  );
};

const LOCAL_STORAGE_KEY = 'selectedWabaNumber'; // Define a key for localStorage

export const WabaNumberSelect = (props) => {
  const dispatch = useDispatch(); // Initialized but not used in the provided logic for this feature

  const [selected, setSelected] = useState(""); // Local state for the OpcSelect component

  // Updated onSelect to handle localStorage
  const onSelect = useCallback((code) => {
    console.log("WabaNumberSelect onSelect triggered with code:", code);
    setSelected(code); // Update local state for OpcSelect

    if (props.onEvent) {
      props.onEvent({ value: code }); // Notify parent component
    }

    // Save to localStorage
    if (code && typeof code === 'string' && code.trim() !== '') {
      localStorage.setItem(LOCAL_STORAGE_KEY, code);
    } else {
      // If selection is cleared or code is invalid, remove from localStorage
      localStorage.removeItem(LOCAL_STORAGE_KEY);
    }
  }, [props.onEvent]); // props.onEvent is a dependency for useCallback

  const showSelectedLabel = true;
  const showSecondarySelectedLabel = props.showSecondarySelectedLabel !== undefined ? props.showSecondarySelectedLabel : false;
  const showOptionLabel = true;
  const showSecondaryOptionLabel = true;
  const searchable = true;

  const [customLabels, setCustomLabels] = useState({});
  const [valueCodes, setValueCodes] = useState([]);

  const userPlans = useSelector((state) => {
    return state.auth.plans;
  });

  useEffect(() => {
    const newCustomLabels = {};
    const newValuesCodes = [];
    let newFirstPhoneNumber = "";

    // 1. Try to get the stored WABA number from localStorage
    const storedWabaNumber = localStorage.getItem(LOCAL_STORAGE_KEY);

    // 2. Process userPlans to build available options
    if (userPlans && userPlans.objects && Array.isArray(userPlans.objects)) {
      userPlans.objects.forEach(plan => {
        if (plan.numbers && Array.isArray(plan.numbers)) {
          plan.numbers.forEach(number => {
            // Ensure number.phone exists and is not expired
            if (number.phone && !number.is_expired) {
              const option = {
                icon: getOpcSelectIcon(),
                data: { plan: plan, number: number },
                primary: number.phone,
                secondary: plan.plan.plan_name, // Ensure plan.plan.plan_name exists
              };
              const key = number.phone;
              newCustomLabels[key] = option;
              newValuesCodes.push(key);
              if (!newFirstPhoneNumber) {
                newFirstPhoneNumber = key; // Capture the first valid phone number
              }
            }
          });
        }
      });
    }

    setValueCodes(newValuesCodes);
    setCustomLabels(newCustomLabels);

    // 3. Determine the initial selection
    let initialSelection = '';
    if (storedWabaNumber && newValuesCodes.includes(storedWabaNumber)) {
      // If a stored number exists and is in the current valid list, use it
      initialSelection = storedWabaNumber;
    } else if (newValuesCodes.length > 0) {
      // Otherwise, if there are valid numbers, use the first one found
      initialSelection = newFirstPhoneNumber;
    }
    // If no valid numbers are found (newValuesCodes is empty), initialSelection remains ''

    // 4. Set the determined selection
    // This will call the local onSelect, which updates local state,
    // notifies the parent, and updates localStorage.
    onSelect(initialSelection);

    // Cleanup function (optional, based on requirements)
    return () => {
      // console.log("WabaNumberSelect unmounting or userPlans changed");
    };
  }, [userPlans, onSelect]); // Added onSelect (memoized by useCallback) to dependency array.
                            // This ensures that if props.onEvent changes, the effect can use the new onSelect.
                            // However, the primary trigger for re-calculating options is userPlans.

  return (
    <div className="row tel-select">
      <div className="col-12 flex-d">
        <div className="opc-select demo-wrapper">
          <OpcSelect
            type={props.opcType || "sr_number"}
            placeholder={props.placeholder || "Select Waba Number"}
            searchPlaceholder={props.searchPlaceholder || "Search Waba Number"}
            selected={selected} // Controlled by local state
            onSelect={onSelect} // Use the local onSelect function
            showSelectedLabel={showSelectedLabel}
            showSecondarySelectedLabel={showSecondarySelectedLabel}
            showOptionLabel={showOptionLabel}
            showSecondaryOptionLabel={showSecondaryOptionLabel}
            customLabels={customLabels}
            countries={valueCodes} // 'countries' prop is used for options list in OpcSelect
            searchable={searchable}
            placeholderIcon={getOpcSelectIcon()}
            optionItemIcon={getOpcSelectIcon()}
            selectButtonClassName={props.selectButtonClassName || "ticker-input2 opselect-form-field-outline"}
            fullWidth={props.fullWidth !== undefined ? props.fullWidth : true}
            disabled={props.disabled || false}
            readOnly={props.readOnly || false}
            componentType={props.componentType}
          />
        </div>
      </div>
    </div>
  );
};